<template>
  <b-modal title="Informações do Produto" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Código:" label-for="codigo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="codigo" v-model="editing.codigo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group
            label="Descrição:"
            label-for="descricao"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="descricao" v-model="editing.descricao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group
            label="Unidade:"
            label-for="unidade"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="unidade" v-model="editing.unidade" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Valor:" label-for="valor" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="valor" v-model.lazy="valorProduto" v-money="money" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group
            label="Peso (Kg):"
            label-for="peso"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="peso" type="number" v-model="editing.peso" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Figura:" label-for="email" label-cols-sm="3" label-align-sm="right">
            <b-form-file
              type="file"
              class="text-left mt-1"
              v-model="arquivo"
              placeholder="Solte o arquivo do produto .jpg"
              drop-placeholder="Solte o arquivo do produto .jpg"
              accept=".jpg"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import Produto from "@/models/Produto";
import Notificacao from "@/models/Notificacao";
import Files from "@/http/files";
import { useSgcqStore } from "@/stores/SgcqStore";
import { useProdutoStore } from "@/stores/ProdutoStore";
import { VMoney } from "v-money";

export default {
  name: "ModalDeEdicaoDeProduto",

  data() {
    return {
      editing: new Produto(0, "Novo produto", "", "", 0.0, "", ""),
      show: false,
      files: new Files(this.$http),
      arquivo: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      valorProduto: 0.0,
    };
  },

  directives: { money: VMoney },

  watch: {
    valorProduto: function (novoValor) {
      let valor = Number(novoValor.split("R$ ").join("").split(".").join("").split(",").join("."));
      this.editing.valor = valor;
    },
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.produtoStore.ALTERAR_PRODUTO(this.editing).then(() => {
          this.store.NOTIFICAR(
            new Notificacao("Produto salvo no SGCQ com sucesso!", "Excelente!", "success")
          );
          if (this.arquivo != null) {
            const filename = this.editing.id + ".jpg";
            let formData = new FormData();
            formData.append("name", this.arquivo.name);
            formData.append("file", this.arquivo);
            this.files.uploadProduto(filename, formData);
          }
        });
      } else {
        this.produtoStore
          .CADASTRAR_PRODUTO(this.editing)
          .then(() =>
            this.store.NOTIFICAR(
              new Notificacao("Produto salvo no SGCQ com sucesso!", "Excelente!", "success")
            )
          );
      }
      this.show = !this.show;
    },

    call(produto) {
      this.editing = produto;
      this.valorProduto = produto.valor.toFixed(2);
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const produtoStore = useProdutoStore();

    return {
      store,
      produtoStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
